export default {
	SET_BILLING_ENTITIES: "SET_PURCHASE_ORDERS",
	SET_LOADING: "SET_LOADING"
};
